import styles from "./IosSpinner.module.css";

const SPINNER_SPOKES = 8;
const SPINNER_DURATION_S = 0.8;

// iOS-style activity indicator: spokes stay fixed, opacity fades round in sequence
export default function IosSpinner({ size = 52 }) {
  return (
    <svg
      className={styles.spinner}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      {Array.from({ length: SPINNER_SPOKES }, (_, i) => (
        <line
          key={i}
          x1="12"
          y1="2.5"
          x2="12"
          y2="7"
          className={styles.spinnerSpoke}
          transform={`rotate(${(360 / SPINNER_SPOKES) * i} 12 12)`}
          style={{
            animationDelay: `${-SPINNER_DURATION_S + (SPINNER_DURATION_S / SPINNER_SPOKES) * i}s`,
          }}
        />
      ))}
    </svg>
  );
}
